// Products that count toward plan limits: an untouched sample product from
// the Store Ready popup doesn't (same rule as the API's /gift/create, which
// clears is_sample once the seller edits it)
export const countOwnProducts = (products) => (products || []).filter((p) => !p.is_sample).length;
